var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDepositHeadingIcon = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.619629,
    width: 51.3803,
    height: 48,
    rx: 6,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8095 14H29.1905C32.2795 14 33.9995 15.78 33.9995 18.83V29.16C33.9995 32.26 32.2795 34 29.1905 34H20.8095C17.7695 34 15.9995 32.26 15.9995 29.16V18.83C15.9995 15.78 17.7695 14 20.8095 14ZM21.0795 18.66V18.65H24.0685C24.4995 18.65 24.8495 19 24.8495 19.429C24.8495 19.87 24.4995 20.22 24.0685 20.22H21.0795C20.6485 20.22 20.2995 19.87 20.2995 19.44C20.2995 19.01 20.6485 18.66 21.0795 18.66ZM21.0795 24.74H28.9195C29.3495 24.74 29.6995 24.39 29.6995 23.96C29.6995 23.53 29.3495 23.179 28.9195 23.179H21.0795C20.6485 23.179 20.2995 23.53 20.2995 23.96C20.2995 24.39 20.6485 24.74 21.0795 24.74ZM21.0795 29.31H28.9195C29.3185 29.27 29.6195 28.929 29.6195 28.53C29.6195 28.12 29.3185 27.78 28.9195 27.74H21.0795C20.7795 27.71 20.4895 27.85 20.3295 28.11C20.1695 28.36 20.1695 28.69 20.3295 28.95C20.4895 29.2 20.7795 29.35 21.0795 29.31Z",
    fill: "#262626"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDepositHeadingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DepositHeadingIcon.c167aa17.svg";
export { ForwardRef as ReactComponent };